module.exports = __webpack_public_path__ + "static/img/Kade-Dykes.e54857f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kade-Dykes.jpg
// module id = fbEs
// module chunks = 0